import { createContext, useContext } from 'react'

type PublishingContextTypes = {
  isCustodian: boolean
}

const PublishingContext = createContext<PublishingContextTypes>({
  isCustodian: false,
})

const usePublishingContext = (): PublishingContextTypes => {
  const { isCustodian } = useContext(PublishingContext)

  return {
    isCustodian,
  }
}

export { PublishingContext, usePublishingContext }
